import { useState, type ReactNode } from "react";
import type { Invoice } from "@plataforma/shared";
import { InvoiceFlow, type InvoiceStep } from "./InvoiceFlow";

/** Estado do diálogo de nota fiscal, reaproveitado pelas telas que disparam a jornada. */
export function useInvoiceFlow(pending: Invoice[] = []): { open: (invoice: Invoice, step: InvoiceStep) => void; dialog: ReactNode } {
  const [current, setCurrent] = useState<{ invoice: Invoice; step: InvoiceStep; justIssued?: boolean } | null>(null);
  const others = current ? pending.filter((item) => item.id !== current.invoice.id) : [];
  return {
    open: (invoice, step) => setCurrent({ invoice, step }),
    dialog: current ? (
      <InvoiceFlow
        key={`${current.invoice.id}-${current.step}`}
        invoice={current.invoice}
        step={current.step}
        justIssued={current.justIssued}
        nextPending={others[0]}
        pendingCount={others.length}
        onStep={(invoice, step, justIssued) => setCurrent({ invoice, step, justIssued })}
        onClose={() => setCurrent(null)}
      />
    ) : null,
  };
}
